var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCursor = function SvgCursor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M741.648,235.748l-17.255-7.934a.785.785,0,0,0-.85.13.763.763,0,0,0-.2.828l6.426,17.467a.772.772,0,0,0,.726.5h.014a.775.775,0,0,0,.723-.528l2.4-7.3,7.857-1.722a.773.773,0,0,0,.6-.667A.764.764,0,0,0,741.648,235.748Z",
    transform: "translate(-716.694 -221.243)"
  })));
};
export default SvgCursor;